// extracted by mini-css-extract-plugin
export var icon = "_wt-0";